import { useCallback, useMemo, useState } from "react"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import { CatalogItemEditStateContext, CatalogItemEditDispatchContext, initialState } from "./CatalogItemEditContext.context"

export const CatalogItemEditContextProvider = (props) => {

    const { children } = props

    const [state, setState] = useState(initialState)

    const setTypeSelectionDisplayed = useCallback((typeSelectionDisplayed) => {
        setState((previousState) => ({
            ...previousState,
            typeSelectionDisplayed: typeSelectionDisplayed,
        }))
    }, [])

    const setOnBack = useCallback((onBackCallback) => {
        setState((previousState) => ({
            ...previousState,
            onBack: onBackCallback,
        }))
    }, [])

    const setMapZoom = useCallback((zoom) => {
        setState((previousState) => ({
            ...previousState,
            mapZoom: zoom,
        }))
    }, [])

    const dispatchValue = useMemo(() => {
        return {
            setMapZoom,
            setTypeSelectionDisplayed,
            setOnBack,
        }
    }, [setMapZoom, setTypeSelectionDisplayed, setOnBack])

    return (
        <CatalogItemEditStateContext.Provider value={state}>
            <CatalogItemEditDispatchContext.Provider value={dispatchValue}>
                {children}
            </CatalogItemEditDispatchContext.Provider>
        </CatalogItemEditStateContext.Provider>
    )
}

CatalogItemEditContextProvider.propTypes = {
    children: PropTypes.node,
}
